import _ from 'lodash';
import text from './resources/locale/en.json';

class Who {
    constructor($sce, $state, $timeout, $window, crConstants, crVenueService, crConfig, crPolicyService) {
        this.$sce = $sce;
        this.$state = $state;
        this.$timeout = $timeout;
        this.crConstants = crConstants;
        this.text = text;
        this.fieldOptions = {};
        this.isSegmentationCollapsed = false;
        this.crVenueService = crVenueService;
        this.crConfig = crConfig;
        this.crPolicyService = crPolicyService;
        this.$window = $window;
        this.trustedHtmlCache = {};
        this.locationEnums = this.crConstants.userLocationEnums;
    }

    $onInit() {
        this.experienceType = _.cloneDeep(this.experienceType);

        this.errorMessages = {
            atLeastOne: this.text.atLeastOne,
            required: '',
        };

        this.isCorporateMarketor = false;

        this.hasUserBehavior =
            this.experienceType.userBehavior &&
            this.experienceType.userBehavior.length &&
            this.experienceType.userBehavior.length > 0;

        if (this.collapseUserTagSection) {
            // If tags are already selected, don't collapse it
            if (this.experience.audience.tags.filter((tag) => tag.key !== null).length === 0) {
                this.isSegmentationCollapsed = true;
            }
        }
        if (this.isAppSelectionBroadcastSupported) {
            this.generateAppList();
            this.mapExistingApps();
        }

        this.hasCorporateMarketerRole();
    }

    $onChanges(changes) {
        if ((changes.tagDefinitions && changes.tagDefinitions.currentValue) ||
            (changes.cohortDefinitions && changes.cohortDefinitions.currentValue)) {
            this.updateCriteriaList();
        }
    }

    $postLink() {
        this.$timeout(() => {
            this.checkBehaviorValidity();
        }, 0);
    }

    get showInclude() {
        return (
            this.experienceType.userTags.include.enabled || !!this.experienceType.userTags.include.overrideDescription
        );
    }

    get showAltInclude() {
        return !!this.experienceType.userTags.include.overrideDescription;
    }

    get showExclude() {
        return (
            this.experienceType.userTags.exclude.enabled || !!this.experienceType.userTags.exclude.overrideDescription
        );
    }

    get showAltExclude() {
        return !!this.experienceType.userTags.exclude.overrideDescription;
    }

    get collapseUserTagSection() {
        return this.experienceType.userTags && this.experienceType.userTags.type === 'COLLAPSED';
    }

    get isUserTagsUnsupported() {
        return this.experienceType.userTags && this.experienceType.userTags.type === 'UNSUPPORTED';
    }

    get isAppSelectionBroadcastSupported() {
        return this.crConfig.customer.configFlags.enable_app_selection_broadcast ||
                !!this.crConfig.customer.configFlags.enable_app_selection_broadcast;
    }

    get isInVenueSelected() {
        const { additionalFields, id } =  this.experienceType
        const location = _.find(additionalFields, { type: 'LOCATION_SELECT' });
        if (location) {
            return (
                id === 'BROADCAST_NOW' &&
                _.get(this.experience, `${location.targetPath}.type`) === 'IN_VENUE'
            );
        }
        return false;
    }

    checkBehaviorValidity() {
        // Checks for cases where the user must choose at least one of multiple fields
        if (this.experienceType.userBehavior) {
            this.experienceType.userBehavior.forEach((behavior, index) => {
                if (
                    !behavior.optional &&
                    behavior.fields.filter((field) => field.optional).length === behavior.fields.length
                ) {
                    let valid = false;
                    behavior.fields.forEach((field) => {
                        if (_.has(this.experience, field.targetPath)) {
                            valid = true;
                        }
                    });
                    this.form[`behavior${index}`].$setValidity('atLeastOne', valid);
                }
            });
        }
    }


    toggleAdvancedSegmentation() {
        this.isSegmentationCollapsed = !this.isSegmentationCollapsed;
    }

    generateAppList() {
        this.userApps = {
            selectedApps: [],
            appOptions: [],
            key: '_userApps'

        };
        this.globalAppIds = [];
        if(this.crConfig.customer.configFlags.global_apps && this.crConfig.customer.configFlags.global_apps.length > 0) {
            this.globalAppIds = this.crConfig.customer.configFlags.global_apps;
        }
        this.userAppsList = this.crVenueService.config.customer
                        .venues.find(venue => venue.id === this.$state.params.venueId)
                        .appConfigs;

        if(this.userAppsList) {
            this.userAppsList.forEach((app) => {
                app.id = app.appId;
                app.label = app.displayName;
                app.appValueKey = app.idMask;
                if(this.globalAppIds) {
                    app.isGlobalApp = this.globalAppIds.includes(app.id);
                }
            });
            this.userApps.appOptions = this.userAppsList;
        }

    }


    mapExistingApps() {
        if(this.experience.appIds && this.experience.appIds.length > 0) {
            const selectedApps = this.experience.appIds;
            this.userApps.selectedApps = selectedApps.map(selectedApp => {
                return this.userApps.appOptions.find((app) => app.id === selectedApp);
            });
        }
    }


    onAppSelect(event) {
        if(event && event.length > 0) {
            const userSelectedApps = event.map(app => app.id);
            const isGlobalAppSelected = _.intersection(userSelectedApps, this.globalAppIds);
            if(!this.isCorporateMarketor && isGlobalAppSelected.length > 0 && this.updateOutOfVenueLocation) {
                this.updateOutOfVenueLocation.updateLocation('remove');
            } else if (this.updateOutOfVenueLocation){
                this.updateOutOfVenueLocation.updateLocation('add');
            }
            this.experience.appIds = userSelectedApps;
        }
    }

    // Return the set of tag definitions and cohort definitions that can be used for the
    // eqCriteria and neCriteria criteria lists.
    getCombinedCriteriaOptions(op) {
        let options = [];

        // Add tag definitions
        if (this.tagDefinitions && this.tagDefinitions.length > 0) {
            options.push(...this.tagDefinitions
                .map((tag) => ({
                ...tag,
                op: op,
                type: tag.type,
                definition: tag,
                isCohort: false,
            })));
        }
        if (op == 'NEQ') {
            // Don't include the fake All App Users tag in the NEQ options
            options = options.filter((tagOption) => !tagOption.isFakeTag);
        }

        if (op == 'EQ') {
            // Add cohort definitions following the existing convention of tags
            if (this.cohortDefinitions && this.cohortDefinitions.length > 0) {
                const cohortOptions = this.cohortDefinitions.map((cohort) => ({
                    customer: this.crConfig.customer.id,
                    tagKey: cohort.id,
                    title: cohort.name,
                    label: cohort.name,
                    values: cohort.values || [],
                    op: op,
                    type: 'COHORT',
                    definition: cohort,
                    isCohort: true
                }));
                options.push(...cohortOptions);
            }
        }

        return options;
    }

    updateCriteriaList() {
        this.eqCriteria = [];
        this.neqCriteria = [];

        // If the 'EQ' tag has the single empty tag crtieria in it, alter the visual display of that
        // to coincide with the "all App Users" tag.
        var allAppsTag = false;
        const currentEqTags = this.experience.audience.tags.filter((tag) => tag.op === 'EQ');
        if (currentEqTags.length === 1) {
            const currentEq = currentEqTags[0];
            if (currentEq.key === null) {
                allAppsTag = true;
                currentEq.key = this.crConstants.appUsersTagKey; // See experience-manage.controller preparePayload()
                currentEq.values = ['all'];
                currentEq.options = null; // Reset for the next step
                currentEq.isCohort = false;
            }
        }
        if (!(allAppsTag && this.experience.audience.cohorts.length > 0)) {
            // For each tag currently on the experience.audience, create an associated tile (eqCriterie element)

            this.experience.audience.tags.forEach((tag) => {
                let tile = {
                    key: tag.key,
                    values: tag.values,
                    isCohort: false,
                    type: 'TAG',
                    options: this.getCombinedCriteriaOptions(tag.op),
                    tag: tag,
                    cohort: null,
                    op: tag.op,
                }

                // Set the rest of the tile definition based on the option selected.
                tile.options.forEach((option) => {
                    const isSelected = option.tagKey === tag.key;
                    option.isSelected = isSelected;

                    if (isSelected) {
                        tile.valueOptions = option.values;
                        tile.definition = option.definition;

                        // populate associated tag values on the tile.
                        tile.fullValues = [];
                        if (tag.values) {
                            tag.values.forEach((valueKey) => {
                                tile.fullValues.push(tile.valueOptions.find((tvo) => valueKey === tvo.tagValueKey));
                            });
                        }
                    }
                });

                if (tag.op === 'EQ') {
                    this.eqCriteria.push(tile);
                } else {
                    this.neqCriteria.push(tile);
                }
            });
        }

        // We should also show eqCriteria tiles for any cohorts.
        // Cohorts can only be used in the "eq" crtieria section, not in the neq
        this.experience.audience.cohorts.forEach((cohort) => {
            let tile = {
                key: cohort.cohortId,
                options: this.getCombinedCriteriaOptions('EQ'),
                op: 'EQ',
                tag: null,
                cohort: cohort,
                type: 'COHORT',
                isCohort: true
            }

            tile.options.forEach((option) => {
                const isSelected = option.tagKey === cohort.cohortId;
                option.isSelected = isSelected;

                if (isSelected) {
                    tile.definition = option.definition;
                    tile.cohortFields = this.cohortParamsAsFields(tile);
                }
            });
            this.eqCriteria.push(tile);
        });
    }

    dirtyForm() {
        this.form.$setDirty();
    }

    removeTagFromExperience(tile) {
        if (tile.tag) {
            // Remove the tag previously represented by this tile
            const index = this.experience.audience.tags.indexOf(tile.tag);
            // Only remove if found (indexOf returns -1 if not found, and splice(-1, 1) removes last element!)
            if (index !== -1) {
                this.experience.audience.tags.splice(index, 1);
            }
            tile.tag = null;
        }
    }

    removeCohortFromExperience(tile) {
        if (tile.cohort) {
            // Remove the cohort previously represented by this tile
            const index = this.experience.audience.cohorts.indexOf(tile.cohort);
            // Only remove if found (indexOf returns -1 if not found, and splice(-1, 1) removes last element!)
            if (index !== -1) {
                this.experience.audience.cohorts.splice(index, 1);
            }
            tile.cohort = null;
        }
    }

    cohortParamTypeToFieldType(cohortParamType) {
        switch (cohortParamType) {
            case 'INTEGER':
            case 'LONG':
            case 'DOUBLE':
                return 'NUMBER';
            case 'STRING':
                return 'TEXT';
            case 'DATE':
            case 'TIME':
            case 'DATETIME':
                return 'TEXT';
            case 'BOOLEAN':
                return 'BOOLEAN';
            default:
                return 'TEXT';
        }
    }

    // Returns the set of cohort parameters in a form which is compatible
    // with a sequence of cr-additional-fields directives.
    cohortParamsAsFields(tile) {
        let index = 0;
        return tile.definition.parameters.map((param) => {
            switch (param.parameterType) {
                case "BOOLEAN":
                    return {
                        key: param.id,
                        description: param.parameterName,
                        type: "SIMPLE_SELECT",
                        units: null,
                        // placeholder: param.parameterName,
                        options: [
                            { label: "true", value: "true"},
                            { label: "false", value: "false"}
                        ],
                        validators: [
                            {
                                type: "REQUIRED",
                                value: true
                            }
                        ],
                        multi: false,
                        optional: false,
                        // this is passed as 'path' to the onCohortParamUpdate function:
                        targetPath: "cohort.params[" + index++ + "].value",
                    }
                    break;
                default:
                    // cohort parameter as a 'field' from experienceType Behavior
                    return {
                        key: param.id,
                        description: param.parameterName,
                        type: this.cohortParamTypeToFieldType(param.parameterType),
                        units: null,
                        placeholder: this.typeSpecificPlaceholder(param.parameterType),
                        validators: [
                            {
                                type: "REQUIRED",
                                value: true
                            }
                        ],
                        multi: false,
                        optional: false,
                        targetPath: "cohort.params[" + index++ + "].value",
                        options: []
                    }
            }
        });
    }

    typeSpecificPlaceholder(cohortParamType) {
        switch (cohortParamType) {
            case 'INTEGER':
            case 'LONG':
            case 'DOUBLE':
                return 0;
            case 'DATE':
                return "YYYY-MM-DD";
            case 'TIME':
                return "HH:MM:SS";
            case 'DATETIME':
                return "YYYY-MM-DD HH:MM:SS";
            default:
                return '';
        }
    }

    onCohortParamUpdate(tile, path, data, checked) {
        console.log('ohCohortParamUpdateCalled: ' + path);
        _.set( tile, path, data);
    }

    initializeCohortParams(cohortDefinition) {
        const params = [];
        cohortDefinition.parameters.forEach((param) => {
            params.push({
                cohortParamName: param.parameterName,
                value: null
            });
        })
        return params;
    }

    // Called when an option is selected in a tile's drop-down choice
    onTagSelect(event, tile) {
        const selectedOption = event.model[0];
        // clear these:
        tile.fullValues = [];
        tile.values = [];

        if (selectedOption && selectedOption.isCohort == false) {
            // A tagKey has been selected...
            // Remove any existing cohort FIRST to avoid digest cycle issues
            this.removeCohortFromExperience(tile);

            tile.key = selectedOption.tagKey;
            tile.definition = selectedOption.definition;
            tile.valueOptions = selectedOption.values;
            tile.type = 'TAG';
            tile.isCohort = false;
            tile.cohortFields = [];
            if (selectedOption.isFakeTag) {
                // Populate the tag values automatically, since the field will be
                // disabled and the user won't be able to do it themselves
                tile.fullValues = selectedOption.values;
                tile.values = tile.fullValues.map((value) => value.tagValueKey);
            }
            // Add the tag to the experience, it does not yet have a value
            if (tile.tag == null) {
                tile.tag = {
                    key: tile.key,
                    op: tile.op,
                    values: tile.fullValues.map((value) => value.tagValueKey)
                }
                this.experience.audience.tags.push(tile.tag);
            }
            else {
                tile.tag.key = tile.key;
                tile.tag.values = tile.fullValues.map((value) => value.tagValueKey);
            }
        }
        else if (selectedOption && selectedOption.isCohort == true) {
            // A cohort has been selected...
            // Remove any existing tag FIRST to avoid digest cycle issues during field initialization
            this.removeTagFromExperience(tile);

            tile.key = selectedOption.tagKey;
            tile.definition = selectedOption.definition;
            tile.valueOptions = selectedOption.values;
            tile.type = 'COHORT';
            tile.isCohort = true;
            // Add the tag to the experience, it does not yet have a value
            if (tile.cohort == null) {
                tile.cohort = {
                    cohortId: tile.key,
                    cohortName: tile.definition.name,
                    params: this.initializeCohortParams(tile.definition)
                }
                this.experience.audience.cohorts.push(tile.cohort);
            }
            else {
                tile.cohort.cohortId = tile.key;
                tile.cohort.cohortName = tile.definition.title;
                tile.cohort.params = this.initializeCohortParams(tile.definition)
            }
            tile.cohortFields = this.cohortParamsAsFields(tile);
        } else {
            tile.key = null;
            tile.definition = null;
            tile.valueOptions = null;
            tile.cohortFields = [];
            this.removeTagFromExperience(tile);
            this.removeCohortFromExperience(tile);
        }
        this.dirtyForm();
    }

    onFieldUpdate(path, data, checked) {
        if (checked) {
            _.set(this.experience, path, data);
        } else {
            _.unset(this.experience, path);
        }

        this.dirtyForm();
        this.checkBehaviorValidity();
    }

   onUpdateAppOptions(locationType) {
        if(this.isAppSelectionBroadcastSupported && this.userApps) {
            if(!this.isCorporateMarketor
                && locationType === this.locationEnums.OUTSIDE_VENUE) {
                this.userApps.appOptions = this.userAppsList.filter(app => !app.isGlobalApp);
            }
            else {
                this.userApps.appOptions = this.userAppsList;
            }
        }
    }

    addTag(op) {
        const tile = {
            key: null,
            type: null,
            values: [],
            isCohort: false,
            options: this.getCombinedCriteriaOptions(op),
            tag: null,
            op: op,
            cohort: null
        }
        if (op == 'EQ') {
            this.eqCriteria.push(tile);
        }
        else {
            this.neqCriteria.push(tile);
        }

        this.dirtyForm();
        //this.updateCriteriaList();
    }

    get eqCriteriaValid() {
        if (this.eqCriteria) {
            for (let i = 0; i < this.eqCriteria.length; i++) {
                const criteria = this.eqCriteria[i];
                if (criteria.isCohort === true) {
                    // TODO: validate cohort parameters have been entered
                }
                else if (!criteria.tag || !criteria.tag.key || !criteria.tag.op || criteria.tag.values.length === 0) {
                    return false;
                }
            }
        }

        return true;
    }

    get neqCriteriaValid() {
        if (this.neqCriteria) {
            for (let i = 0; i < this.neqCriteria.length; i++) {
                const criteria = this.eqCriteria[i];
                if (criteria.isCohort === true) {
                    // TODO: validate cohort parameters have been entered
                }
                else if (!criteria.tag.key || !criteria.tag.op || criteria.tag.values.length === 0) {
                    return false;
                }
            }
        }

        return true;
    }

    onValueSelect(values, tile) {
        if (tile.tag) {
            if (values === null) {
                tile.fullValues = [];
                tile.values = [];
            } else {
                tile.fullValues = values;
                tile.values = values.map((value) => value.tagValueKey);
            }
            tile.tag.values = tile.values;
        }
        this.dirtyForm();
    }

    onDateTagDateUpdate(event, tile) {
        if (!event.model) {
            tile.tag.values = [];
        } else {
            tile.tag.values = [event.model];
        }
        this.dirtyForm();
    }

    removeTag(tile) {
        this.removeTagFromExperience(tile)
        this.removeCohortFromExperience(tile)
        // Remove the tile from the eqCriteria or neqCriteria
        let index = this.eqCriteria.indexOf(tile);
        if (index !== -1) {
            this.eqCriteria.splice(index, 1);
        }
        else {
            index = this.neqCriteria.indexOf(tile);
            this.neqCriteria.splice(index, 1);
        }
        this.dirtyForm();
        // this.updateCriteriaList();
    }

    hasExamples(behavior) {
        return behavior.examples && behavior.examples.length;
    }

    getExampleHtml(behavior) {
        const html = behavior.examples
            .map(
                (example) => `<div class="title">${_.escape(example.title)}</div>
             <div class="description">${_.escape(example.description)}</div>`
            )
            .join('');

        if (!this.trustedHtmlCache[html]) {
            this.trustedHtmlCache[html] = this.$sce.trustAsHtml(html);
        }

        return this.trustedHtmlCache[html];
    }

    hasCorporateMarketerRole() {
        this.crPolicyService.hasRole('exp_corporate_marketer').then(res => this.isCorporateMarketor = res);
    }
}

export default Who;
